// src/components/Footer.js
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { LanguageContext } from '../translations/LanguageContext';

function Footer() {
  const { language, translations } = useContext(LanguageContext);
  const footerLinks = translations[language].footer;
  const footerInfo = translations[language].footerInfo;

  return (
    <footer className="footer">
      <div className="footer-links">
        <Link to="/about" className="footer-link">
          {footerLinks.aboutMe}
        </Link>
        <Link to="/contact" className="footer-link">
          {footerLinks.contact}
        </Link>
      </div>
      <div className="footer-info">
        <Link to="/legal" className="footer-link">
          {footerInfo.legal}
        </Link>
        <Link to="/privacy" className="footer-link">
          {footerInfo.privacy}
        </Link>
        <p className="copyright">
          {footerInfo.copyright}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
